// extracted by mini-css-extract-plugin
module.exports = {"component":"Card_component_3_Eqv","closeButton":"Card_closeButton_mcuaH"};